'use client';

import { type JSX, type ReactNode } from 'react';

import { Text } from '@videoblocks/design-system';
import { Keep } from '@videoblocks/design-system/icons';

interface TopResultsSectionProps {
    count: number;
    children: ReactNode;
}

export function TopResultsSection({ count, children }: TopResultsSectionProps): JSX.Element {
    return (
        <section className="px-6 pt-4">
            <div className="flex flex-col gap-2 rounded-lg bg-white p-4 shadow-[0_0_16px_0_rgba(0,0,0,0.2)]">
                <div className="flex items-center gap-2">
                    <Keep width={16} height={16} className="shrink-0 [&_path]:fill-gray-800" />
                    <Text asChild fontSize="base" fontWeight="semibold" className="text-gray-800">
                        <h2>
                            Top {count} {count === 1 ? 'Result' : 'Results'}
                        </h2>
                    </Text>
                </div>
                {children}
            </div>
        </section>
    );
}
